export default () => ({
	// We load the whole app here and it is our source of truth for components, theme and other app related things
	app: null,

	// Currently rendered component ID
	// This is important as renderers are using this to determine which component to render
	selectedComponentId: "",

	// Node operations
	hoveredNodeId: "",
	selectedNodeIds: [],
	expandedNodeIds: [] // TODO: hmm maybe doesn't need to be global state, it is useful only for the layout inspector
})
